export function formalizedItemFromUrl(): { langPathName: string, locale: string, redirectUri: string, origin: string } {
    let langPathName: string = '';
    let locale: string = '';
    let redirectUri: string = '';
    let origin: string = '';

    // localhost

    if (window.location.hostname == 'localhost') {
        langPathName = 'en';
        locale = 'en';
        redirectUri = window.location.origin;

        return { langPathName, locale, redirectUri, origin: window.location.origin };
    }

    let isProduction: boolean = true;
    for (let item of ['develop', 'feature', 'bugfix', 'VL-', 'VG-']) {
        if (window.location.pathname.includes(item)) {
            isProduction = false;
            break;
        }
    }

    if (isProduction) {
        // Production
        // www.verygames.com/en/ -> ['', 'en']
        langPathName = window.location.pathname.split('/')[1];

        // If the lang path name is not 2, we are using en as silent check sso, we say that it's the default path :)
        // the length is not exact if a user are using www.verygames.com/cart
        if (langPathName.length != 2) {
            langPathName = 'en';
        }

        locale = langPathName;
        redirectUri = location.origin + '/' + locale
        origin = window.location.origin;
    }

    // Developement
    // www.verygames.com/develop/en/ ['', 'develop', 'en']
    else {
        let path: string[] = window.location.pathname.split('/');

        // If the lang path name is not 2, we are using en as silent check sso, we say that it's the default path :)
        // the length is not exact if a user are using www.verygames.com/develop/cart
        if (path[2].length != 2) {
            path[2] = 'en';
        }

        langPathName = `${path[1]}/${path[2]}`;
        locale = path[2];
        redirectUri = location.origin + '/' + langPathName;
        origin = window.location.origin + '/' + path[1];
    }

    return { langPathName, locale, redirectUri, origin };
}